    import React, { useState, useEffect } from "react";
    import { useParams } from "react-router-dom";
    import { useDropzone } from "react-dropzone";
    import { auth } from "../../../config/firebaseConfig";
    import {
    getStorage,
    ref,
    uploadBytes,
    getDownloadURL,
    deleteObject,
    } from "firebase/storage";
    import {
    getFirestore,
    collection,
    doc,
    addDoc,
    deleteDoc,
    getDocs,
    serverTimestamp,
    } from "firebase/firestore";
    import { v4 as uuidv4 } from "uuid";
    import "./tab05.css";

    const DropzoneWrapper = ({ category, onDrop, children }) => {
    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    return (
        <div className="file-category-box">
        <h3>{category}</h3>
        <div {...getRootProps()} className="dropzone">
            <input {...getInputProps()} />
            <p>ここにファイルをドラッグ＆ドロップするか、クリックして選択</p>
        </div>
        <div>{children}</div>
        </div>
    );
    };

    const Tab05 = () => {
    const { masterID } = useParams();
    const [categories, setCategories] = useState([
        "制御盤 詳細図面",
        "設備 詳細図面",
        "設備関連写真",
    ]);
    const [filesByCategory, setFilesByCategory] = useState({});
    const [userId, setUserId] = useState("");
    const [currentProjectID, setCurrentProjectID] = useState(
        localStorage.getItem("currentProjectID")
    );

    // プレビュー用のstate
    const [previewState, setPreviewState] = useState({});
    const [previewFile, setPreviewFile] = useState(null);


    const db = getFirestore();
    const storage = getStorage();

    useEffect(() => {
        const currentUser = auth.currentUser;
        if (currentUser) {
        setUserId(currentUser.uid);
        }
    }, []);

    useEffect(() => {
        categories.forEach((category) => fetchFiles(category));
    }, [categories]);

    const fetchFiles = async (category) => {
        if (!currentProjectID) {
            console.warn("projectID が undefined のため fetchFiles を中止しました。");
            return;
        }

        const snapshot = await getDocs(
            collection(db, "projects", currentProjectID, "masters", masterID, "files")
        );
        const files = snapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter((file) => file.category?.trim() === category.trim());

        setFilesByCategory((prev) => ({ ...prev, [category]: files || [] }));
    };


    const handleFileUpload = async (file, category) => {
        try {
        const existing = filesByCategory[category]?.find(
            (f) => f.fileName === file.name
        );
        if (existing) {
            alert(
            `同じファイル名「${file.name}」はすでに存在しています。別のファイル名にしてください。`
            );
            return;
        }

        const fileID = uuidv4();
        const storageRef = ref(
            storage,
            `files/${currentProjectID}/${masterID}/${category}/${file.name}`
        );
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);

        const fileMeta = {
            uploadedBy: userId,
            projectID: currentProjectID,
            masterID: masterID || "",
            category,
            fileName: file.name,
            fileSize: file.size,
            mimeType: file.type || "unknown",
            downloadURL,
            uploadedAt: serverTimestamp(),
        };

        await addDoc(
            collection(
            db,
            "projects",
            currentProjectID,
            "masters",
            masterID,
            "files"
            ),
            fileMeta
        );
        fetchFiles(category);
        } catch (error) {
        console.error("ファイルアップロードに失敗:", error);
        alert("ファイルのアップロードに失敗しました。もう一度お試しください。");
        }
    };

    const handleDelete = async (file) => {
        const confirmDelete = window.confirm(
        `本当に「${file.fileName}」を削除しますか？`
        );
        if (!confirmDelete) return;

        try {
        const storageRef = ref(
            storage,
            `files/${currentProjectID}/${file.masterID}/${file.category}/${file.fileName}`
        );
        await deleteObject(storageRef);

        if (file.id) {
            await deleteDoc(
            doc(
                db,
                "projects",
                currentProjectID,
                "masters",
                masterID,
                "files",
                file.id
            )
            );
        }
        fetchFiles(file.category);
        } catch (error) {
        console.error("削除に失敗しました:", error);
        alert("削除に失敗しました。再度お試しください。");
        }
    };

    const handleAddCategory = () => {
        const newCategory = prompt("新しいカテゴリ名を入力してください")?.trim();

        if (newCategory && !categories.includes(newCategory)) {
            const updatedCategories = [...categories, newCategory];
            setCategories(updatedCategories); // 状態更新
            setFilesByCategory((prev) => ({
            ...prev,
            [newCategory]: [] // 追加したカテゴリ用に空配列を初期化
            }));
        }
    };


    const renderPreview = (file) => {
        const ext = file.fileName.split(".").pop()?.toLowerCase();
        if (["png", "jpg", "jpeg", "gif"].includes(ext)) {
        return (
            <img src={file.downloadURL} alt={file.fileName} style={{ maxWidth: "200px" }} />
        );
        }
        if (ext === "pdf") {
        return (
            <iframe
            src={file.downloadURL}
            title={file.fileName}
            style={{ width: "200px", height: "250px", border: "none" }}
            />
        );
        }
        return <span>プレビューなし</span>;
    };


// 画面内に表示ver
    const PreviewModal = ({ file, onClose }) => {
        if (!file) return null;
        const ext = file.fileName.split(".").pop()?.toLowerCase();

        return (
            <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <h3 style={{ marginBottom: "1rem" }}>{file.fileName}</h3>
                {["png", "jpg", "jpeg", "gif"].includes(ext) && (
                <img src={file.downloadURL} alt={file.fileName} className="modal-image" />
                )}
                {ext === "pdf" && (
                <iframe
                    src={file.downloadURL}
                    title={file.fileName}
                    className="modal-iframe"
                />
                )}
                <button className="modal-close" onClick={onClose}>✖ 閉じる</button>
            </div>
            </div>
        );
    };

// モーダル画面ver
    return (
        <div className="file-upload-manager">
        <h2>📁 ファイルアップロード</h2>
        <div className="file-category-container">
            {categories.map((category) => (
            <DropzoneWrapper
                key={category}
                category={category}
                onDrop={(acceptedFiles) => {
                acceptedFiles.forEach((file) => handleFileUpload(file, category));
                }}
            >
                {filesByCategory[category]?.map((file) => (

// 画面内に表示ver
                // <div key={file.id} className="file-item">
                //     <strong>{file.fileName}</strong>
                //     <button
                //         onClick={() =>
                //             setPreviewState((prev) => ({
                //             ...prev,
                //             [file.id]: !prev[file.id],
                //             }))
                //         }
                //         >
                //         {previewState[file.id] ? "プレビューを隠す" : "🔍 プレビュー表示"}
                //     </button>
                //     {previewState[file.id] && (
                //         <div className="file-preview">{renderPreview(file)}</div>
                //     )}
                //     <a href={file.downloadURL} target="_blank" rel="noopener noreferrer">
                //     ダウンロード
                //     </a>
                //     <button onClick={() => handleDelete(file)} style={{ marginLeft: "1em" }}>
                //     削除
                //     </button>
                // </div>
// モーダル画面ver
                <div key={file.id} className="file-item">
                    <strong>{file.fileName}</strong>

                    <button onClick={() => setPreviewFile(file)}>
                        🔍 プレビュー表示
                    </button>

                    <a href={file.downloadURL} target="_blank" rel="noopener noreferrer">
                        ダウンロード
                    </a>

                    <button onClick={() => handleDelete(file)} style={{ marginLeft: "1em" }}>
                        削除
                    </button>
                </div>

                ))}
            </DropzoneWrapper>
            ))}
        </div>

        {/* <button onClick={handleAddCategory} className="add-category-button">
            ＋ ファイル保存カテゴリを追加
        </button> */}

        {previewFile && <PreviewModal file={previewFile} onClose={() => setPreviewFile(null)} />}

        </div>
    );
    };

    export default Tab05;
